import { dialog } from "../../nq-component";
import BaseListPresenter from "../../base/BaseListPresenter";
import { deleteObjectUseCase, upsertUseCase } from "../../usecases/object";

class UserPresenter extends BaseListPresenter {
  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["countPoints", "all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.filterLocation = "";
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        location: this.filterLocation
          ? {
              $elemMatch: {
                id: this.filterLocation, // Use the filter location if set
              },
            }
          : undefined,
      },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }
  async onClickItemDelete(index) {
    dialog.close();
    const object = this.objects[index].id;
    const collection = this.view.getCollectionName();
    await deleteObjectUseCase().execute(collection, object);
    this.objects.splice(index, 1);

    this.view.setObjects(this.objects);
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/users-form");
  }

  onClickItem(index) {
    const object = this.objects[index];
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/users-form/" + object.id);
  }

  // filterSubmit(where) {
  //   this.reset();
  //   this.filter = where;
  //   this.getObjects();
  // }

  filterSubmit(where) {
    const locationId = where.locationP?.id;
    this.reset();
    this.filterLocation = locationId;
    this.getObjects();
  }

  async onClickStatus(index) {
    const object = this.objects[index];
    console.log("update", object);
    object.status = object.status === "Active" ? "InActive" : "Active";
    const collection = this.view.getCollectionName();
    const newObject = await upsertUseCase().execute(collection, object);
    this.objects[index] = object;
    console.log("asas", this.objects);
    this.view.setObjects(this.objects);
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }
}

export default UserPresenter;
